import React from 'react';
import FerramentaManager from '../components/FerramentaManager/FerramentaManager.jsx';

export default function Ferramentas() {
  return <FerramentaManager />;
}
